import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
// import "react-phone-input-2/lib/style.css";

import ScrollToTop from "./ScrollToTop";
import { persistor, store } from "store/store";
import App from "./App";
import { Toaster } from "react-hot-toast";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
        <ScrollToTop />
        <Toaster />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
